import {UserRegisterButton} from "./buttons/UserRegisterButton";
import React, {useEffect, useState} from "react";
import useApi from "../hooks/useApi";
import AnimatedNumbers from "react-animated-numbers"

export const PrizeMoney = ({ showRegisterButton }) => {
    const [amount, setAmount] = useState<number | null>(null);
    const {backend} = useApi();

    useEffect(() => {
        console.log('PrizeMoney useEffect');
        backend.ladder.ladderControllerGetLadderPrizeMoney().then((res) => {
            setAmount(res.prizeMoney);
        });
    }, []);
    return (
        <>
            <div className="flex flex-col w-full bg-green-600 text-center py-4 lg:px-4 place-content-center items-center">
                <div className={'flex flex-row items-center'}>
                <div className={'text-4xl'}>🏆</div>
                <div className="p-2 flex items-center justify-center lg:rounded-full flex-col text-center">
                    <span className="font-semibold text-sm text-indigo-100 mr-2">Předpokládaná výhra</span>
                    <span className="font-semibold text-4xl text-indigo-100 mr-2 flex flex-row items-center gap-3">
                       {/*{amount}*/}
                        {amount !== null && (
                        <AnimatedNumbers
                            className={''}
                            locale="cs-CZ"
                            transitions={(index) => ({
                                type: "spring",
                                duration: index + 0.5,
                            })}
                            animateToNumber={amount}
                            fontStyle={{
                                fontSize: 40,
                                color: "white",
                            }}
                        />
                        )}
                       <span>Kč</span>
                    </span>
                    <span
                        className="font-normal text-indigo-100 text-xs">prize money se upřesňuje podle registrovaných uživatelů</span>
                </div>
                <div className={'text-4xl'}>🏆</div>
                </div>
                <div>
                    <div
                        className="bg-green-700 p-2 items-center text-indigo-100 leading-none rounded-full flex lg:inline-flex mr-3"
                        role="alert">
                            {/*<span className="flex rounded-full bg-green-500 uppercase px-2 py-1 text-xs font-bold mr-3">Registrační poplatek</span>*/}
                        <span className="font-semibold mr-2 text-left flex-auto px-2 py-1">Registrační poplatek činí pouze 100 Kč</span>
                    </div>
                </div>
                <div>
                    {showRegisterButton && (
                        <UserRegisterButton smHideText={false} />
                    )}
                </div>
            </div>
        </>
    );
};
